import { HttpClient } from 'api/http-client';
import { ProjectPhase } from 'api/project';

export interface UpdateTaskOrderPayload {
  taskOrder: number[];
}

class PhaseAPIClient extends HttpClient {
  public updateTaskOrder = (
    phaseId: number,
    payload: UpdateTaskOrderPayload,
  ): Promise<null> => {
    return this.put(`/phases/${phaseId}/update-task-order`, payload);
  };

  public getProjectPhase = (phaseId: number): Promise<ProjectPhase> => {
    return this.get(`/phases/${phaseId}`);
  };

  public async createDependentPhase(
    phaseId: number,
    data,
  ): Promise<ProjectPhase> {
    return this.post(`/phases/${phaseId}/add-dependency`, data);
  }

  public async removeDependentPhase(phaseId: number, data): Promise<boolean> {
    return this.post(`/phases/${phaseId}/remove-dependency`, data);
  }
}

export const PhaseAPI = new PhaseAPIClient();
